export const shouldRequestFakeData = () => {
  const params = new URLSearchParams(window.location.search)
  return !!params.get('fake_data')
}

export const fakeDataScenario = () => {
  const params = new URLSearchParams(window.location.search)
  return params.get('scenario')
}
